import Input from "@/components/atoms/input";
import { MAX_PASSWORD_LENGTH } from "@/consts";
import * as ViewModel from '@/core/presenter/viewModel';

interface IProps {
    className: string;
    id: string;
    placeholder: string;
    label: string;
    password?: string;
    isCheckPasswordDisabled?: boolean;
    onChange?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onBlur?: (e: React.SyntheticEvent<HTMLInputElement>) => void;
    onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const InputPassword = ({className, id, placeholder, label, password, onChange, onBlur, onKeyDown}: IProps): JSX.Element => {
    return (
        <div className="form-group">
            <label htmlFor={id}>{label}</label>
            <Input type="password" className={className} value={password} id={id} placeholder={placeholder} validatorType={ViewModel.InputValidatorType.PASSWORD} maxLength={MAX_PASSWORD_LENGTH} onChange={onChange} onBlur={onBlur} onKeyDown={onKeyDown} />
        </div>
    )
}

export default InputPassword;


